import { useAtomValue } from 'jotai';
import { $ThingsData } from '~/models/100things';
import { Avatar, Button, ButtonSize } from '@lemon8/design';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { $RootTraffic, $UserAgent, $Locale } from '@lemon8/web-app-shared/atom';
import createOpenUrl from '~/utils/createOpenUrl';
import { $ShareInfo } from '~/models/share-info';
import { createOnelink } from '~/utils/createOneLink';
import Logo from '~/assets/logo.png';
import Search from '~/assets/search.png';
import LogoLongEn from '~/assets/US_1.png';
import LogoLongJp from '~/assets/JP_1.png';
import LogoLongTh from '~/assets/TH_1.png';
import p1 from '~/assets/p1.png';
import p2 from '~/assets/p2.png';
import p3 from '~/assets/p3.png';
import p4 from '~/assets/p4.png';
import s1 from '~/assets/s1.png';
import s2 from '~/assets/s2.png';
import s3 from '~/assets/s3.png';
import s4 from '~/assets/s4.png';
const backList = [p1, p2, p3, p4];
const sugList = [s1, s2, s3, s4];

import './style.scss';
import { ACTIVITY_PID } from '../constants';

const geckoUrlWithoutPageChangeQuery =
  'https://lf16-sourcecdn-tos.ibytedtos.com/obj/byte-gurd-source-sg/62/gecko/resource/100ideas/html/landing-page.html?position=wap';

const schema =
  'snssdk2657://webview?url=https%3A%2F%2Flf16-sourcecdn-tos.ibytedtos.com%2Fobj%2Fbyte-gurd-source-sg%2F62%2Fgecko%2Fresource%2F100ideas%2Fhtml%2Flanding-page.html%3Fposition%3Dwap&hide_navigation_bar=1&allow_change_statusbar=1&disable_bounces=1';
const sslocal = schema.replace('snssdk2657', 'sslocal');

const logoList: any = {
  us: LogoLongEn,
  gb: LogoLongEn,
  jp: LogoLongJp,
  th: LogoLongTh,
};

let hasLeave = false;
let hasLog = false;

export default function ThingsPage() {
  const data = useAtomValue($ThingsData);
  const { isMobile, isiOS, isInApp } = useAtomValue($UserAgent);
  const { trafficPid: trafficType } = useAtomValue($RootTraffic);
  const { t } = useTranslation();
  const { sharePlatform, sharePageName } = useAtomValue($ShareInfo);
  const [date] = useState<Date>(new Date(Number(`${data.create_time}000` || '')));
  const { region } = useAtomValue($Locale);
  const logoLong = logoList[region] || logoList['us'];

  const commonParams: Record<string, string> = {
    campaign_id: data?.campaignId || 'ideabuckets',
    share_platform: data?.sharePlatform || '',
  };

  const goto = (): void => {
    const openUrl = createOpenUrl({
      url: `${geckoUrlWithoutPageChangeQuery}`,
      useTitlebar: false,
      useStatusBar: false,
      preventBounces: true,
    });

    const params: any = {
      share_platform: sharePlatform, // 分享平台
      share_position: sharePageName, // 分享页面来源
      share_type: commonParams.share_type, // 分享类型
    };

    const onelink = createOnelink({
      url: 'https://lemon8.onelink.me/FMQw',
      pid: ACTIVITY_PID,
      testOpenUrl: openUrl,
      deepLinkValue: { type: 'campaign', id: 'ideabuckets' },
      afDp: schema,
      afDpParams: {
        pid: 'ideabuckets',
        ...params,
      },
      ampExtra: {
        traffic_type: trafficType,
        enter_page_id: 'ideabuckets',
        enter_page_type: 'activity',
        ...params,
      },
      isiOS,
      isMobile,
    });

    window.open(onelink);
  };

  const onClick = (): void => {
    window.Tea('wap_click_campaign_page_invite', {
      ...commonParams,
    });
    if (isInApp) {
      // 端内进行了点击，直接跳转活动页面
      window.location.href = sslocal;
      return;
    }
    goto();
  };

  useEffect(() => {
    if (isInApp && !hasLeave) {
      // 端内打开了回流页，跳转到活动承接页
      window.location.href = sslocal;

      hasLeave = true;

      return;
    }

    if (!hasLog) {
      window.Tea('wap_enter_campaign_page_invite', {
        ...commonParams,
      });

      hasLog = true;
    }
    return () => {};
  }, []);
  return (
    <div className="things-activity">
      <div className="backflow-banner">
        <img className="backflow-banner-image" src={Logo}></img>
        <div className="backflow-banner-search" onClick={onClick}>
          <div className="backflow-banner-search-l">
            <div className="backflow-banner-search-icon">
              <img src={Search}></img>
            </div>
            <div className="backflow-banner-search-input">{t('bucketList_landingPage_barFill')}</div>
          </div>
          <div className="backflow-banner-search-btn">{t('bucketList_landingPage_bar_btn')}</div>
        </div>
      </div>

      <div className="backflow-header" onClick={onClick}>
        <div className="backflow-header-sug">
          <img src={logoLong} />
          <p>{`${date.toLocaleDateString()}`}</p>
        </div>
        <div className="backflow-header-content">
          <div className="backflow-header-content-l">
            <p>{data.ideas?.length || 0}</p>
            <span>{t('bucketList_result_completed')}</span>
          </div>
          <div className="backflow-header-content-r">
            <img className="backflow-header-content-r-pic" src={backList[Number(data?.pendant_id) - 1 || 0]}></img>
            <img className="backflow-header-content-r-sub" src={sugList[Number(data?.pendant_id) - 1 || 0]}></img>
            <Avatar
              size={88}
              className="backflow-header-content-r-ava"
              src={data?.user_info?.avatar_url || ''}
            ></Avatar>
            <span>{data?.user_info?.user_nick_name || ''}</span>
          </div>
        </div>
      </div>
      <div className="backflow-circle">
        <div className="backflow-circle-black"></div>
      </div>
      <div className="backflow-body" onClick={onClick}>
        {data?.ideas?.map((item, index) => {
          return (
            <div className="backflow-body-item" key={item?.idea?.idea_id}>
              <div className={item?.item?.cover_img ? 'backflow-body-item-img' : 'backflow-body-item-icon'} />
              <img src={item?.item?.cover_img || item?.idea?.icon} />
              <span>{item?.idea?.text}</span>
            </div>
          );
        })}
        <div className="backflow-body-corner"></div>
        <div className="backflow-body-corner-tran"></div>
      </div>

      <div className="backflow-bottom" onClick={onClick}>
        <Button
          variant="Primary"
          size={ButtonSize.large}
          title={t('bucketList_landingPage_btn')}
          className="backflow-bottom-inner"
        ></Button>
      </div>
    </div>
  );
}
